export class DataCapture {
    AppSeqId:string;
    embossingName:string;
    resiStatus:string;
    resiStdCode: string;
    yearsAtCurrentResi:string;
    fathersName:string;
    mothersName:string;
    preferredMailAddress:string;
    feeCode:string;
    userId:string;
    permPinCode:string;
    permState:string;
    applicationNumber:string;
    qualification:string;
    alternateCardNumber:string;
    existingRelwithSBI:string;
    sbiAccountNo:string;
    isPermResiAddressSame:string;
    perCity:string;
    offCity:string;
    offStdCode: string;
    perHouseNo:string;
    perLocality:string;
    perAddLine:string;
    officialEmailId:string;
    offPhone:string;
    businessType: string;
    offAddLine1:string;
    offAddLine2:string;
    offLandmark:string;
    offPincode:string;
    amaId:string;
    frequentFlyer:string;
    ckycNumber:string;
    cppConsent:string;
    isInternationalUsageDisabled:string;
    contactlessDomestic:string;
    contactlessInternational:string;
    domesticOnline:string;
    internationalOnline:string;
    posInternational:string;
    consentGiven:string;
    annualIncome:string;
    personalEmailId:string;

}
